module.exports = __webpack_public_path__ + "img/jxk-icon3.575adb34.png";